<div class="flex-column flex-middle bg-col-34 b-radius-20 m-b">
    <h2 class="h2-bold center m-b-3 p-t-3">
        @if (newSpcpNumber) {
        {{'Your new SagePay Cloud Payment number' | translate}}:&nbsp;{{newSpcpNumber}}
        } @else {
        {{'Your SagePay Cloud Payment number' | translate}}:&nbsp;{{successData.sccp_payment_reference}}
        }
    </h2>
    <div class="w-12 flex flex-middle p-l-2 p-r-2 p-b-2">
        <button class="w-12 m-r-2 button-1"
                sl-button="back"
                [routerLink]="'/'"><span class="button__body">{{'Back to store' | translate}}</span>
        </button>
        <action class="w-12 button"
                [status]="status"
                (click)="renew()">
            {{'Renew Payment' | translate}}
        </action>
    </div>
    <result class="w-12 center p-t-1"
            [status]="status" />
</div>
